import { extractImageCropFromTag } from "@faire/images/cropTags/extractImageCropFromTag";
import {
  optimizeImageUrl,
  optimizeImageUrlFillSquare,
} from "@faire/images/optimizeImages";
import { IImage } from "@faire/types-common-api/indigofair/data/IImage";

import { AVATAR_LARGEST_SIZE } from "./consts";

export const getAvatarImageUrl = (
  image: IImage | undefined
): string | undefined => {
  if (!image) {
    return undefined;
  }

  if (extractImageCropFromTag(image.tags)) {
    return optimizeImageUrl(image, false, {
      width: IMAGE_SIZE,
      height: IMAGE_SIZE,
      dprOverride: 1,
    });
  }

  return optimizeImageUrlFillSquare(image, false, IMAGE_SIZE, {
    dprOverride: 1,
  });
};

// we always use the largest size for the avatar, to optimize CDN cache hits
const IMAGE_SIZE = AVATAR_LARGEST_SIZE * 2;
